/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { SocieteExterneGridDto } from './SocieteExterneGridDto';
import {
    SocieteExterneGridDtoFromJSON,
    SocieteExterneGridDtoFromJSONTyped,
    SocieteExterneGridDtoToJSON,
} from './SocieteExterneGridDto';

/**
 * 
 * @export
 * @interface SocieteExterneGridDtoPaginatedResults
 */
export interface SocieteExterneGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof SocieteExterneGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SocieteExterneGridDto>}
     * @memberof SocieteExterneGridDtoPaginatedResults
     */
    results?: Array<SocieteExterneGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof SocieteExterneGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the SocieteExterneGridDtoPaginatedResults interface.
 */
export function instanceOfSocieteExterneGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SocieteExterneGridDtoPaginatedResultsFromJSON(json: any): SocieteExterneGridDtoPaginatedResults {
    return SocieteExterneGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function SocieteExterneGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocieteExterneGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(SocieteExterneGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function SocieteExterneGridDtoPaginatedResultsToJSON(value?: SocieteExterneGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(SocieteExterneGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

